module.exports = __webpack_public_path__ + "static/media/simon.3d0fabb4.png";